import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { textTranslations } from './done/text-translations';
import { useLanguage } from './LanguageContext';
import Header from './Header';
import Footer from './Footer';


const Error = () => {

  const { language } = useLanguage();

  const [doneType, setDoneType] = useState("acknowledged");

  const [searchParams, setSearchParams] = useSearchParams();

  const twilio_conversation_id = window.localStorage.getItem("twilio_conversation_id");

  const p = window.localStorage.getItem("p");

  const goToNext = () => {
    if(doneType === "payment") {
      window.location.replace(`/t/${twilio_conversation_id}/upload/${p}?lang=english`, "_blank");
    }
    if(doneType === "upload") {
      window.location.replace("https://theboggler.com/account", "_self");
    }
    if(doneType === "acknowledged") {
      window.location.replace("https://youtu.be/ayEMo-lQuw8?si=UiDIDaqPM80Lq34j", "_blank");
    }
  }
  useEffect(() => {
    const type = searchParams.get("type");
    if (type) {
      setDoneType(type);
    }
    setTimeout(() => {
      window.close();
    }, 3000);
  }, []);

  return (
    <div onClick={goToNext} style={{ cursor: "pointer" }}>
     <Header />
     <section className="main-body-section">
        <div style={{textAlign: "center", height: "auto", fontSize: "42px", padding: "20px"}}>
          {doneType === "payment" && textTranslations("payment", language)}
          {doneType === "upload" && textTranslations("upload", language)}
          {doneType === "acknowledged" && textTranslations("acknowledged", language)}
        </div>
        <div style={{ position: "relative", textAlign: 'center', minHeight: "58vh" }}>
          <div style={{position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)"}}>
            <img className="pulsing-boggler-logo" src="https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/boggler-logo-clear.webp" alt="Boggler Logo" />
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}

export default Error;
